// import React, { useState } from "react";
// import axios from "axios";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// import AdminAppBar from "../adminComponents/AdminAppBar";
// import { showErrorToast } from "../Constant/Notification";
// import { ToastContainer } from "react-toastify";

// const ReportMain = () => {
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [reportType, setReportType] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleDownload = async () => {
//     if (!startDate || !endDate || !reportType) {
//       showErrorToast("Please select start date, end date, and report type");
//       return;
//     }

//     if (new Date(startDate) > new Date(endDate)) {
//       showErrorToast("Start date cannot be later than the end date.");
//       return;
//     }

//     try {
//       setLoading(true);
//       const formatToDDMMYYYY = (date) => {
//         const [yyyy, mm, dd] = date.split("-");
//         return `${mm}-${dd}-${yyyy}`;
//       };

//       const formattedStartDate = formatToDDMMYYYY(startDate);
//       const formattedEndDate = formatToDDMMYYYY(endDate);

//       let response;
//       if (reportType === "booking") {
//         response = await axios.get(
//           `https://client-glfunnel-service-144135692330.asia-south1.run.app/api/v1/booking-report?startDate=${formattedStartDate}&endDate=${formattedEndDate}`
//         );
//       } else if (reportType === "agreement") {
//         response = await axios.get(
//           `https://client-glfunnel-service-144135692330.asia-south1.run.app/api/v1/overall-agreement-report?startDate=${formattedStartDate}&endDate=${formattedEndDate}`
//         );
//       }

//       const reportData = response.data;
//       if (!Array.isArray(reportData) || reportData.length === 0) {
//         showErrorToast("No data found for the selected criteria.");
//         return;
//       }

//       const workbook = new ExcelJS.Workbook();
//       const worksheet = workbook.addWorksheet("Report");

//       const headers = Object.keys(reportData[0]);
//       worksheet.columns = headers.map((header) => ({
//         header: header.trim(),
//         key: header,
//         width: 20,
//       }));

//       // Set header styles
//       worksheet.getRow(1).eachCell((cell) => {
//         if (reportType == "booking") {
//           cell.font = { bold: true, color: { argb: "FF0070C0" } };
//           cell.fill = {
//             type: "pattern",
//             pattern: "solid",
//             fgColor: { argb: "F8CBAD" },
//           };
//           cell.alignment = { vertical: "middle", horizontal: "center" };
//           cell.border = {
//             top: { style: "thin" },
//             left: { style: "thin" },
//             bottom: { style: "thin" },
//             right: { style: "thin" },
//           };
//         } else if (reportType === "agreement") {
//           cell.font = { bold: true };
//           cell.fill = {
//             type: "pattern",
//             pattern: "solid",
//             fgColor: { argb: "B4C6E7" },
//           };
//           cell.alignment = { vertical: "middle", horizontal: "center" };
//           cell.border = {
//             top: { style: "thin" },
//             left: { style: "thin" },
//             bottom: { style: "thin" },
//             right: { style: "thin" },
//           };
//         }
//       });

//       // Add data rows
//       reportData.forEach((item) => {
//         worksheet.addRow(item);
//       });

//       worksheet.eachRow((row, rowNumber) => {
//         if (rowNumber !== 1) {
//           row.height = 30;
//           row.eachCell((cell) => {
//             cell.alignment = { vertical: "middle", horizontal: "center" };
//             cell.border = {
//               top: { style: "thin" },
//               left: { style: "thin" },
//               bottom: { style: "thin" },
//               right: { style: "thin" },
//             };
//           });
//         } else {
//           row.height = 60; // Header row height
//         }
//       });

//       const buffer = await workbook.xlsx.writeBuffer();
//       const blob = new Blob([buffer], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });
//       saveAs(blob, `${reportType}_report_${startDate}_${endDate}.xlsx`);
//     } catch (error) {
//       console.error("Error downloading report:", error);
//       showErrorToast("Failed to download report.");
//     } finally {
//       setLoading(false);
//     }
//   };
//   const getLocalDate = () => {
//     const now = new Date();
//     const offset = now.getTimezoneOffset(); // Get timezone offset in minutes
//     const localDate = new Date(now.getTime() - offset * 60 * 1000); // Adjust for local timezone
//     return localDate.toISOString().split("T")[0];
//   };
//   return (
//     <div className="bg-appGrayBackground">
//        <AdminAppBar />
//       <ToastContainer />
//       <div className="flex flex-col justify-center xl:px-6 pt-5 min-h-screen">
//         <div className="text-left">
//           <h2 className="text-4xl 3xl:text-[45px]  font-semibold text-gray-900 mb-6 whitespace-nowrap">
//             Report Module
//           </h2>
//         </div>

//         <div className="bg-white flex flex-col rounded-lg w-full shadow-lg px-20 py-10">
//           <form>
//             <div className="flex gap-7 px-12 items-center ">
//               <div className="flex flex-col">
//                 <div>
//                   <label className="block text-gray-700 text-xl 3xl:text-[35px] font-bold mb-2 3xl:mb-16 whitespace-nowrap">
//                     Please Select
//                   </label>
//                 </div>
//                 <div className="flex gap-14">
//                   <div className="mb-4">
//                     <label
//                       className="block text-gray-700 text-sm 3xl:text-[30px] 3xl:mb-11 font-bold mb-2 whitespace-nowrap"
//                       htmlFor="start-date"
//                     >
//                       Start Date
//                     </label>
//                     <input
//                       type="date"
//                       id="start-date"
//                       className="w-full px-3 py-2 border rounded-lg 3xl:text-[25px]  focus:outline-none focus:ring-2 focus:ring-green-600"
//                       value={startDate}
//                       // max={new Date().toISOString().split('T')[0]}
//                       max={getLocalDate()}
//                       onChange={(e) => setStartDate(e.target.value)}
//                     />
//                   </div>

//                   <div className="mb-4">
//                     <label
//                       className="block text-gray-700 text-sm 3xl:text-[30px] 3xl:mb-11 font-bold mb-2 whitespace-nowrap"
//                       htmlFor="end-date"
//                     >
//                       End Date
//                     </label>
//                     <input
//                       type="date"
//                       id="end-date"
//                       className="w-full px-3 py-2 border rounded-lg  3xl:text-[25px] focus:outline-none focus:ring-2 focus:ring-green-600"
//                       value={endDate}
//                       // max={new Date().toISOString().split('T')[0]}
//                       max={getLocalDate()}
//                       onChange={(e) => setEndDate(e.target.value)}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="mb-4 px-12">
//               <label className="block text-gray-700 text-xl 3xl:text-[30px]  3xl:mb-11 3xl:mt-8 font-bold mb-2 whitespace-nowrap">
//                 Report Type
//               </label>

//               <div className="flex justify-start items-center 3xl:text-[30px]  gap-20 mt-10">
//                 <label className="inline-flex items-center">
//                   <input
//                     type="radio"
//                     name="report-type"
//                     value="booking"
//                     checked={reportType === "booking"}
//                     onChange={(e) => setReportType(e.target.value)}
//                     className="form-radio h-4 w-4 text-green-600"
//                   />
//                   <span className="ml-2 whitespace-nowrap">Booking Report</span>
//                 </label>
//                 <label className="inline-flex items-center">
//                   <input
//                     type="radio"
//                     name="report-type"
//                     value="agreement"
//                     checked={reportType === "agreement"}
//                     onChange={(e) => setReportType(e.target.value)}
//                     className="form-radio h-4 w-4 text-green-600"
//                   />
//                   <span className="ml-2 whitespace-nowrap">
//                     Agreement Report
//                   </span>
//                 </label>
//               </div>
//             </div>
//             {/* <div className="mt-10 justify-end flex">
//               <button
//                 type="button"
//                 onClick={handleDownload}
//                 className="border border-emerald-700 py-2 px-4 whitespace-nowrap rounded-lg text-emerald-600 transition duration-200 flex items-center justify-center"
//               >
//                 Download Report
//                 <svg
//                   className="ml-2 h-4 w-4"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M14 5l7 7m0 0l-7 7m7-7H3"
//                   />
//                 </svg>
//               </button>
//             </div> */}

//             <div className="flex justify-end">
//               <button
//                 type="button"
//                 onClick={handleDownload}
//                 className="border border-emerald-700 py-2 px-4 whitespace-nowrap rounded-lg text-emerald-600 transition duration-200 flex items-center justify-center"
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <div className="flex justify-center items-center h-full ">
//                       <div className="animate-spin rounded-full h-8 w-8  border-t-4 border-b-4 border-customGreen"></div>
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <span className="3xl:text-[25px] ">Download Report</span>
//                     <svg
//                       className="ml-2 h-4 w-4 3xl:w-6 3xl:h-6"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M14 5l7 7m0 0l-7 7m7-7H3"
//                       />
//                     </svg>
//                   </>
//                 )}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReportMain;

import React, { useState } from "react";
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import AdminAppBar from "../adminComponents/AdminAppBar";
import { showErrorToast } from "../Constant/Notification";
import { ToastContainer } from "react-toastify";
import ReportService from "../Services/ReportService";
import Loader from "../Constant/Loader";
import { getIcons } from "../Constant/Constant";

const ReportMain = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reportType, setReportType] = useState("");
  const [loading, setLoading] = useState(false);
  const Icon = getIcons();

  const handleDownload = async () => {
    if (!startDate || !endDate || !reportType) {
      showErrorToast("Please select start date, end date, and report type");
      return;
    }

    if (new Date(startDate) > new Date(endDate)) {
      showErrorToast("Start date cannot be later than the end date.");
      return;
    }

    try {
      setLoading(true);
      const formatToDDMMYYYY = (date) => {
        const [yyyy, mm, dd] = date.split("-");
        return `${mm}-${dd}-${yyyy}`;
      };

      const formattedStartDate = formatToDDMMYYYY(startDate);
      const formattedEndDate = formatToDDMMYYYY(endDate);

      let response;
      if (reportType === "booking") {
        response = await ReportService.fetchBookingReport(
          formattedStartDate,
          formattedEndDate
        );
      } else if (reportType === "agreement") {
        response = await ReportService.fegtchAgreementReport(
          formattedStartDate,
          formattedEndDate
        );
      } else if (reportType === "siteVisit") {
        response = await ReportService.fetchSiteVisitReport(
          formattedStartDate,
          formattedEndDate
        );

      }else if (reportType === "afterSiteVisit") {
        response = await ReportService.fetchAfterSitevisitReport(
          formattedStartDate,
          formattedEndDate
        );
        
      }
      
      else if (reportType === "fullyRegistered") {
        response = await ReportService.fetchFullyRegisteredReport(
          formattedStartDate,
          formattedEndDate
          );
        }else if (reportType === "sitting") {
          response = await ReportService.fetchSittingReport(
            formattedStartDate,
            formattedEndDate
            );
            }
            else if (reportType === "afterSitting") {
              response = await ReportService.fetchAfterSittingReport(
                formattedStartDate,
                formattedEndDate
                );
                }
                else if (reportType === "advanceAmount") {
                  response = await ReportService.fetchAdvanceAmountReport(
                    formattedStartDate,
                    formattedEndDate
                    );
                    }
                    else if (reportType === "registrationProgress") {
                      response = await ReportService.fetchRegistrationProgressReport(
                        formattedStartDate,
                        formattedEndDate
                        );
                        }
                else if (reportType === "dealLostAfter") {
                  response = await ReportService.fetchDealLostAfterReport(
                    formattedStartDate,
                    formattedEndDate
                    );
                    }
                    else if (reportType === "dealLostBefore") {
                      response = await ReportService.fetchDealLostBeforeReport(
                        formattedStartDate,
                        formattedEndDate
                        );
                        }

      const reportData = response.data;
      if (!Array.isArray(reportData) || reportData.length === 0) {
        showErrorToast("No data found for the selected criteria.");
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Report");

      const headers = Object.keys(reportData[0]);
      worksheet.columns = headers.map((header) => ({
        header: header.trim(),
        key: header,
        width: 20,
      }));

      // Set header styles
      worksheet.getRow(1).eachCell((cell) => {
        if (reportType == "booking") {
          cell.font = { bold: true, color: { argb: "FF0070C0" } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "F8CBAD" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        } else if (reportType === "agreement") {
          cell.font = { bold: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "B4C6E7" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        } else if (reportType === "siteVisit") {
          cell.font = { bold: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "C4C6E4" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
        else if (reportType === "advanceAmount") {
          cell.font = { bold: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "C4C6E4" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
        else if (reportType === "registrationProgress") {
          cell.font = { bold: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "C4C6E4" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
        else if (reportType === "dealLostAfter") {
          cell.font = { bold: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "C4C6E4" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
        else if (reportType === "dealLostBefore") {
          cell.font = { bold: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "C4C6E4" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
        else if (reportType === "afterSitting") {
          cell.font = { bold: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "C4C6E4" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
        else if (reportType === "fullyRegistered") {
          cell.font = { bold: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "C4C6E4" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
        else if (reportType === "sitting") {
          cell.font = { bold: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "C4C6E4" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
      
      });

      // Add data rows
      reportData.forEach((item) => {
        worksheet.addRow(item);
      });

      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber !== 1) {
          row.height = 30;
          row.eachCell((cell) => {
            cell.alignment = { vertical: "middle", horizontal: "center" };
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        } else {
          row.height = 60; // Header row height
        }
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${reportType}_report_${startDate}_${endDate}.xlsx`);
    } catch (error) {
      console.error("Error downloading report:", error);
      showErrorToast("Failed to download report.");
    } finally {
      setLoading(false);
    }
  };
  const getLocalDate = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset(); // Get timezone offset in minutes
    const localDate = new Date(now.getTime() - offset * 60 * 1000); // Adjust for local timezone
    return localDate.toISOString().split("T")[0];
  };
  return (
    <div className="bg-appGrayBackground">
      {loading ? <Loader /> : ""}
       <AdminAppBar />
      <ToastContainer />
      {/* <div className="flex flex-col  xl:px-6 pt-5 min-h-screen">
        <div className="text-left mt-32">
          <h2 className="text-4xl 3xl:text-[45px]  font-semibold text-gray-900 mb-6 whitespace-nowrap">
            Report Module
          </h2>
        </div>



        <div className="bg-white flex  rounded-lg w-full shadow-lg px-20 py-10">
        <div>
          <img
          src={Icon?.reportBanner}
          className="rounded-lg"
          />
        </div>
          <form>
            <div className="flex gap-7 px-12 items-center ">
              <div className="flex flex-col">
                <div>
                  <label className="block text-gray-700 text-xl 3xl:text-[35px] font-bold mb-2 3xl:mb-16 whitespace-nowrap">
                    Please Select
                  </label>
                </div>
                <div className="flex gap-14">
                  <div className="mb-4">
                    <label
                      className="block text-gray-700 text-sm 3xl:text-[30px] 3xl:mb-11 font-bold mb-2 whitespace-nowrap"
                      htmlFor="start-date"
                    >
                      Start Date
                    </label>
                    <input
                      type="date"
                      id="start-date"
                      className="w-full px-3 py-2 border rounded-lg 3xl:text-[25px]  focus:outline-none focus:ring-2 focus:ring-green-600"
                      value={startDate}
                      // max={new Date().toISOString().split('T')[0]}
                      max={getLocalDate()}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>

                  <div className="mb-4">
                    <label
                      className="block text-gray-700 text-sm 3xl:text-[30px] 3xl:mb-11 font-bold mb-2 whitespace-nowrap"
                      htmlFor="end-date"
                    >
                      End Date
                    </label>
                    <input
                      type="date"
                      id="end-date"
                      className="w-full px-3 py-2 border rounded-lg  3xl:text-[25px] focus:outline-none focus:ring-2 focus:ring-green-600"
                      value={endDate}
                      // max={new Date().toISOString().split('T')[0]}
                      max={getLocalDate()}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-4 px-12">
              <label className="block text-gray-700 text-xl 3xl:text-[30px]  3xl:mb-11 3xl:mt-8 font-bold mb-2 whitespace-nowrap">
                Report Type
              </label>

              <div className="flex justify-start items-center 3xl:text-[30px]  gap-20 ">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="report-type"
                    value="booking"
                    checked={reportType === "booking"}
                    onChange={(e) => setReportType(e.target.value)}
                    className="form-radio h-4 w-4 text-green-600"
                  />
                  <span className="ml-2 whitespace-nowrap">Booking Report</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="report-type"
                    value="agreement"
                    checked={reportType === "agreement"}
                    onChange={(e) => setReportType(e.target.value)}
                    className="form-radio h-4 w-4 text-green-600"
                  />
                  <span className="ml-2 whitespace-nowrap">
                    Agreement Report
                  </span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="report-type"
                    value="siteVisit"
                    checked={reportType === "siteVisit"}
                    onChange={(e) => setReportType(e.target.value)}
                    className="form-radio h-4 w-4 text-green-600"
                  />
                  <span className="ml-2 whitespace-nowrap">
                    Site Visit Report
                  </span>
                </label>
              </div>
            </div>


            <div className="flex justify-end">
              <button
                type="button"
                onClick={handleDownload}
                className="border border-emerald-700 py-2 px-4 whitespace-nowrap rounded-lg text-emerald-600 transition duration-200 flex items-center justify-center"
                disabled={loading}
              >

                  <>
                    <span className="3xl:text-[25px] ">Download Report</span>
                    <svg
                      className="ml-2 h-4 w-4 3xl:w-6 3xl:h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  </>

              </button>
            </div>
          </form>
        </div>
      </div> */}

      <div className="flex flex-col xl:px-6 pt-5 min-h-screen bg-gray-100">
        <div className="text-left mt-20">
          <h2 className="text-4xl font-semibold text-gray-900 mb-6">
            Report Module
          </h2>
        </div>

        <div className="bg-white flex  gap-16 rounded-lg w-full shadow-lg px-10 py-8 md:px-14 md:py-8">
          <div className=" w-1/2 ">
            <img
              src={Icon?.reportBanner}
              alt="Report Banner"
              className="rounded-lg w-full "
            />
          </div>

          <form className="flex flex-col gap-4 w-1/2">
            <div className="mb-6">
              <label className="block text-gray-700 text-xl font-bold mb-2">
                Please Select
              </label>
              <div className="flex flex-col md:flex-row gap-9">
                {/* Start Date */}
                <div className="flex-1">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Start Date
                  </label>
                  <input
                    type="date"
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
                    value={startDate}
                    max={getLocalDate()}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>

                {/* End Date */}
                <div className="flex-1">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    End Date
                  </label>
                  <input
                    type="date"
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600"
                    value={endDate}
                    max={getLocalDate()}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Report Type Selection */}
            <div className="mb-6">
              <label className="block text-gray-700 text-xl font-bold mb-2">
                Report Type
              </label>
              <select
                value={reportType}
                onChange={(e) => setReportType(e.target.value)}
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600 bg-white"
              >
                <option value="" disabled>
                  Select Report Type
                </option>
                <option value="siteVisit">Site Visit Report</option>
                <option value="afterSiteVisit"> After Site Visit Report</option>
                <option value="sitting">Sitting Report</option>
                <option value="afterSitting">After Sitting Report</option>

              
                <option value="booking">Booking Report</option>
                {/* <option value="agreement">Agreement Report</option> */}
                <option value="advanceAmount">Advance Amount Report</option>
                <option value="registrationProgress">Registration In Progress Report</option>
              
                <option value="fullyRegistered">Fully Registered</option>
                <option value="dealLostBefore">Deal Lost Before Report</option>
                <option value="dealLostAfter">Deal Lost After Report</option>
               
              </select>
            </div>

            <div className="flex justify-end mt-10">
              <button
                type="button"
                onClick={handleDownload}
                className="border border-emerald-700 py-2 px-4 whitespace-nowrap rounded-lg text-emerald-600 transition duration-200 flex items-center justify-center"
                disabled={loading}
              >
                <>
                  <span className="3xl:text-[25px] ">Download Report</span>
                  <svg
                    className="ml-2 h-4 w-4 3xl:w-6 3xl:h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ReportMain;
